import "./switch_caracter.css";
import { WrapperComponent, CircularBtn } from "./../../../_imports";
import HandshakeImg from "./../../../../assets/imgs/mockups/handshake.png";
import Logo from "./../../../../assets/logo/logo.svg";

function SwitchCaracter() {
    return (
        <div className="switch-section-wrapper">
            <WrapperComponent>
                <div className="switch-header">
                    <h2 className="switch-title">QUER SABER COMO A TONALIDA PODE TE AJUDAR?</h2>
                    <p className="switch-subtitle">Somos especializados em encontrar candidatos para vagas de transição</p>
                </div>

                <section className="switch-content">
                    <div className="switch-side switch-company">
                        <h3 className="side-title enterprise">Para Empresas</h3>
                        <p className="side-description">
                            Revolucione seu processo de recrutamento com a Tonalida, cadastre suas vagas em nossa plataforma e utilize a TonIA para realizar entrevistas preliminares de forma inteligente, eficiente e personalizada. Receba currículos já analisados, economize tempo e foque no que realmente importa fechar suas vagas rotativas com menor tempo e custo.
                        </p>
                        <CircularBtn text="Saiba Mais" link="/empresa" variant="company" />
                    </div>

                    <div className="switch-visual-container">
                        <div className="visual-wrapper">
                            <img src={Logo} alt="Logo Tonalida" className="visual-bg-logo" />
                            <img src={HandshakeImg} alt="Aperto de mãos simbolizando parceria" className="visual-image" />
                        </div>
                    </div>

                    <div className="switch-side switch-candidate">
                        <h3 className="side-title candidate">Para Candidatos</h3>
                        <p className="side-description">
                            Dê o próximo grande passo na sua carreira, baixe nosso aplicativo, cadastre seu currículo e realize entrevistas com nossa IA a qualquer hora e em qualquer lugar.<br /> Demonstre todo o seu potencial para as melhores empresas do mercado, destaque-se da concorrência e acelere sua contratação.
                        </p>
                        <CircularBtn text="Saiba Mais" link="/candidato" variant="candidate" />
                    </div>
                </section>
            </WrapperComponent>
        </div>
    );
}

export default SwitchCaracter;